import { createSelector } from 'helpers/reselect'
import { getStoreDetails } from 'selectors/getStoreDetails'

export const getStoreCityAndState = createSelector(
  [getStoreDetails],
  ({
    storeAddress: {
      city,
      state
    } = {}
  } = {}) => `${city}, ${state}`
)

export default createSelector(
  [getStoreDetails]
)
